import PropTypes from "prop-types";
import React from "react";
import DocumentUpload from "../DocumentUpload";
import IntegrationType from "../IntegrationType";
import KitDownload from "../KitDownload";
import Trail from "../Trail";
import Storage from "../../../../utils/storage";

const NoApplication = (props) => {
  const {
    state,
    selectType,
    docApproved,
    ipPermitForm,
    docUpload,
    kitDownloadStatus,
    selectIntTypeStatus,
    uploadStartStatus,
    uploadFinishStatus,
    ipFormStatus,
    publicKeyStatus,
    runTestStatus,
    scheduleMigrationStatus,
    docApproval,
    requestManager,
    ipPermitApproval,
    testApproval,
    migrationApproval,
    docs,
    getApplications,
    getSingleApplication,
  } = props;

  const first = kitDownloadStatus(null) && JSON.parse(kitDownloadStatus(null));
  const second =
    selectIntTypeStatus(null) && JSON.parse(selectIntTypeStatus(null));
  const third = docApproval(null) && JSON.parse(docApproval(null));

  return (
    <div>
      <Trail
        kit={state.kit}
        kitDownloadStatus={kitDownloadStatus(null)}
        selectType={state.selectType}
        selectIntTypeStatus={selectIntTypeStatus(null)}
        uploadStartStatus={uploadStartStatus}
        uploadFinishStatus={uploadFinishStatus(null)}
        ipFormStatus={ipFormStatus(null)}
        publicKeyStatus={publicKeyStatus(null)}
        runTestStatus={runTestStatus(null)}
        scheduleMigrationStatus={scheduleMigrationStatus(null)}
        docApproval={docApproval(null)}
        requestManager={requestManager(null)}
        ipPermitApproval={ipPermitApproval(null)}
        testApproval={testApproval(null)}
        migrationApproval={migrationApproval(null)}
      />

      <div className="nip-integration">
        {state.kit && !first ? (
          <KitDownload goToNext={selectType} />
        ) : first && !second && !third && !docApproved ? (
          <IntegrationType goToNext={docUpload} />
        ) : (
          first &&
          second &&
          !third &&
          !docApproved && (
            <DocumentUpload
              goToNext={ipPermitForm}
              goToPrev={docUpload}
              selection={Storage.get("selection-single")}
              showDocUpload={docUpload}
              acctNumber={Storage.get("account-number")}
              wsdlUrl={Storage.get("wsdl-url")}
              docs={docs}
              getAllApplications={getApplications}
              getSingleApplication={getSingleApplication}
            />
          )
        )}
      </div>
    </div>
  );
};

NoApplication.propTypes = {
  docApproval: PropTypes.func,
  docApproved: PropTypes.any,
  docUpload: PropTypes.any,
  docs: PropTypes.any,
  getApplications: PropTypes.any,
  getSingleApplication: PropTypes.any,
  ipFormStatus: PropTypes.func,
  ipPermitApproval: PropTypes.func,
  ipPermitForm: PropTypes.any,
  kitDownloadStatus: PropTypes.func,
  managerId: PropTypes.any,
  migrationApproval: PropTypes.func,
  publicKeyStatus: PropTypes.func,
  requestManager: PropTypes.func,
  runTestStatus: PropTypes.func,
  runTests: PropTypes.any,
  scheduleMigrationStatus: PropTypes.func,
  selectIntTypeStatus: PropTypes.func,
  selectType: PropTypes.any,
  shareKeys: PropTypes.any,
  startIpSubmission: PropTypes.any,
  state: PropTypes.shape({
    kit: PropTypes.any,
    selectType: PropTypes.any,
  }),
  testApproval: PropTypes.func,
  uploadFinishStatus: PropTypes.func,
  uploadStartStatus: PropTypes.any,
};

export default NoApplication;
